import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { BUTTON_DATA } from 'src/app/modules/shared/models';
import { PrInitiatorService } from 'src/app/modules/pr-initiator/services/pr-initiator.service';
import { TabService } from 'src/app/modules/shared/services/tab.service';

@Component({
  selector: 'app-reject-remarks',
  templateUrl: './reject-remarks.component.html',
  styleUrls: ['./reject-remarks.component.scss']
})
export class RejectRemarksComponent implements OnInit {
  prDetails?: any;
  collective! :any;;
  payload:any
  public remarks!: string;
  public statusForm!: FormGroup;

  constructor(private _prInitiatorService:PrInitiatorService,
    public bsModalRef: BsModalRef,
    private _authServie: AuthService,
    private _formBuilder: FormBuilder,
    private _toastrService : ToastrService,
    private _loaderService : NgxUiLoaderService,
    private tabService:TabService
  ) {
      this.statusForm = this._formBuilder.group({
        remarks : [null, [Validators.required]]
      });
      
     }

  ngOnInit(): void {
    console.log('Payload received:', this.payload);
  }
public approveRejectPR(){
  
  if(this.remarks)
this.payload.remark=this.remarks;
  console.log(this.payload)
  this._prInitiatorService.approveRejectPR(this.payload).subscribe((res:any)=>{
    if(res.status == 200){
      this._toastrService.success(res.message)
      this.tabService.backToHome();
      this.bsModalRef.hide();
    }
  })

}
  }





 


     
